import { useEffect, useState } from "react";

export default function UseractiveAtComponent({ activeAt }) {
  const [online, setOnline] = useState(false);

  const setUserActivityStatus = () => {
    if (!activeAt) {
      setOnline(false);
      return;
    }

    const activeTime = new Date(activeAt);
    const currentTime = new Date();

    const difference = currentTime - activeTime;

    setOnline(difference >= 0 && difference < 60 * 1000);
  };

  useEffect(() => {
    setUserActivityStatus();

    const interval = setInterval(setUserActivityStatus, 1000);

    return () => clearInterval(interval);
  }, [activeAt]);

  return <div className={`activity-status ${online ? "activity-status--online" : ""}`} />;
}
